<template lang="pug">
  .stamp.ml-2(:class="[ isSuccess ? 'stamp-success' : 'stamp-normal' ]")
</template>

<script>
export default {
  props: {
    isSuccess: {
      type: Boolean,
    },
  },
}
</script>

<style scoped>
.stamp {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.stamp-success {
  background-color: #14AE5C;
}
.stamp-normal {
  background-color: #C1C1C1;
}
</style>